"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _fn2 = require("../../../../../../helpers/fn");
var _selectors2 = require("../../../../store/selectors");
var _selectors3 = require("../../store/selectors");
var _excluded = ["queriesIDs"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var withPricesMatrixDropdownBodyProps = function withPricesMatrixDropdownBodyProps(Component) {
  var WithPricesMatrixDropdownBody = function WithPricesMatrixDropdownBody(_ref) {
    var queriesIDs = _ref.queriesIDs,
      props = _objectWithoutProperties(_ref, _excluded);
    var hotelID = props.hotelID;
    var getOffersFromPrices = (0, _react.useMemo)(function () {
      return (0, _selectors2.createGetOffersFromPrices)(queriesIDs);
    }, [queriesIDs]);
    var offersFromPrices = (0, _reactRedux.useSelector)(getOffersFromPrices);
    var getIsDone = (0, _react.useMemo)(function () {
      return (0, _selectors2.createGetIsDone)(queriesIDs);
    }, [queriesIDs]);
    var isDone = (0, _reactRedux.useSelector)(getIsDone);
    var isProcessSelector = (0, _react.useMemo)(function () {
      return (0, _selectors2.createIsProccessSelector)(queriesIDs);
    }, [queriesIDs]);
    var searching = (0, _reactRedux.useSelector)(isProcessSelector);
    var mainQuery = (0, _reactRedux.useSelector)(_selectors3.getMainQuery);
    var hotel = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getHotel)()(state, hotelID);
    });
    var nightsRange = (0, _react.useMemo)(function () {
      var nightsRangeByOffers = R.call(R.pipe(R.groupBy(R.prop('nights')), R.keys, R.map(Number), function (nights) {
        return {
          from: Math.min.apply(Math, _toConsumableArray(nights)),
          to: Math.max.apply(Math, _toConsumableArray(nights))
        };
      }), offersFromPrices);
      var _mainQuery$get$toJS = mainQuery.get(_fn.QUERY_PARAMS.DURATION).toJS(),
        from = _mainQuery$get$toJS.from,
        to = _mainQuery$get$toJS.to;
      return R.range(Math.min(nightsRangeByOffers.from, from), R.inc(Math.max(nightsRangeByOffers.to, to)));
    }, [offersFromPrices, mainQuery]);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      doneSearch: isDone,
      hotelName: "".concat(hotel.name, " ").concat((0, _fn2.combineHotelStars)(hotel.stars, hotel.secondaryStars)),
      nightsRange: nightsRange,
      offers: offersFromPrices,
      queriesIDs: queriesIDs,
      searching: searching
    }));
  };
  WithPricesMatrixDropdownBody.propTypes = {
    country: _propTypes.default.shape({
      id: _propTypes.default.number.isRequired
    }).isRequired,
    hotelID: _propTypes.default.number.isRequired,
    queriesIDs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  };
  return WithPricesMatrixDropdownBody;
};
var _default = exports.default = withPricesMatrixDropdownBodyProps;